'use strict';


var defaultParams = {
    url: 'about:blank',
    top: 0,
    left: 0,
    visible: 'hidden',
    width: window.innerWidth || screen.width,
    height: window.innerHeight || screen.height
};


/* eslint no-invalid-this: 0 */
function hideIframe () {
    // if ( PLATFORM === 'TIZEN' || PLATFORM === 'SMARTTV' || PLATFORM === 'WEBOS' ) {
    this.style.display = 'none';
    // } else {
    //     this.style.visibility = 'hidden';
    // }
    this.isVisible = false;

    if ( DEVELOP ) {
        debug('iframe')(this.src + ' visibility change: ' + this.isVisible);
    }
}

function showIframe () {
    // if ( PLATFORM === 'TIZEN' || PLATFORM === 'SMARTTV' || PLATFORM === 'WEBOS' ) {
    this.style.display = '';
    // } else {
    //     this.style.visibility = '';
    // }
    this.isVisible = true;

    if ( DEVELOP ) {
        debug('iframe')(this.src + ' visibility change: ' + this.isVisible);
    }
}


switch ( defaultParams.height ) {
    case 480:
    case 576:
    case 720:
    case 1080:
        break;

    default:
        defaultParams.width = 1280;
        defaultParams.height = 720;
        break;
}


/**
 * Iframe fabric.
 *
 * @param {Object} params - iframe creating options
 *
 * @return {HTMLIFrameElement} iframe
 */
module.exports = function ( params ) {
    var $iframe = document.createElement('iframe'),
        testRequest;

    if ( typeof params.onload === 'function' ) {
        $iframe.onload = params.onload;
    }

    $iframe.show = showIframe;
    $iframe.hide = hideIframe;
    $iframe.isVisible = null;

    $iframe.style.width = params.width || defaultParams.width + 'px';
    $iframe.style.height = params.height || defaultParams.height + 'px';
    $iframe.style.top = params.top || defaultParams.top;
    $iframe.style.left = params.left || defaultParams.left;

    if ( params.visible ) {
        $iframe.show();
    } else {
        $iframe.hide();
    }

    $iframe.src = params.url || defaultParams.url;

    if ( PLATFORM === 'MAG' ) {
        if ( params.onerror ) {
            testRequest = new XMLHttpRequest();
            testRequest.open('HEAD', $iframe.src);
            testRequest.timeout = 10000;
            testRequest.onload = function () {
                if ( this.status !== 200 ) {
                    if ( !(this.status === 0 && $iframe.src.indexOf('file://') !== -1) ) {
                        params.onerror(this.status);
                    }
                }
            };
            testRequest.onerror = function () {
                params.onerror(this.status);
            };
            testRequest.ontimeout = function () {
                params.onerror(this.status);
            };
            testRequest.send();
        }
    } else if ( !params.height && $iframe.src !== defaultParams.url ) {
        $iframe.src += '?screenHeight=' + defaultParams.height;
    }


    params.$container.appendChild($iframe);
    if ( params.type && params.type !== 'app' ) {
        $iframe.contentWindow.system = require('../system/system');
    }
    /* eslint no-empty-function: 0 */
    $iframe.contentWindow.alert = function () {};
    //$iframe.contentWindow.console = {
    //    log: function ( str ) { у
    //        gSTB.Debug(str);
    //    },
    //    assert: function (  ) {
    //
    //    }
    //};
    //= function () {
    //    alert(444)
    //};


    //if ( DEVELOP ) {
    //    setTimeout(function () {
    //        var url = 'https://wallpapers.wallhaven.cc/wallpapers/full/wallhaven-346609.jpg';
    //        url = 'http://www.look.com.ua/pic/201309/1920x1080/look.com.ua-76174.jpg';
    //        url = 'http://animedia.tv/storage/users/blog/12/56d1950b32f25.jpg';
    //        url = 'http://mag.moe/wp-content/uploads/2015/07/%E3%80%8ALovelive-The-School-Idol-Movie%E3%80%8B%CE%BCs%E5%BD%A2%E8%B1%A1%E6%89%8B%E6%9C%BA%E9%98%B2%E5%B0%98%E5%A1%9E-1.jpg';
    //        url = 'http://mmbiz.qpic.cn/mmbiz/oL8bwv4sibbDu5v2TuNxfzVRvKXuasMQ7rmovTa4mwjGlwaQvYjcvtrguHqT1HJ3CpvFUhB1WAcl5F2Kml60NhQ/0?wx_fmt=jpeg';
    //
    //        $iframe.contentDocument.body.style.cssText = 'background:url(https://www.excitewallpapers.com/wp-content/uploads/Kantai-Collection-Wallpaper-1.jpg) no-repeat #fff !important;background-size: contain;';
    //    }, 4000);
    //}

    return $iframe;
};
